import { render, staticRenderFns } from "./forceReaderingMessageModel.vue?vue&type=template&id=4a451428&scoped=true"
import script from "./forceReaderingMessageModel.vue?vue&type=script&lang=js"
export * from "./forceReaderingMessageModel.vue?vue&type=script&lang=js"
import style0 from "./forceReaderingMessageModel.vue?vue&type=style&index=0&id=4a451428&lang=scss"
import style1 from "./forceReaderingMessageModel.vue?vue&type=style&index=1&id=4a451428&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a451428",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a451428')) {
      api.createRecord('4a451428', component.options)
    } else {
      api.reload('4a451428', component.options)
    }
    module.hot.accept("./forceReaderingMessageModel.vue?vue&type=template&id=4a451428&scoped=true", function () {
      api.rerender('4a451428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/message/forceReaderingMessageModel.vue"
export default component.exports